module.exports = __webpack_public_path__ + "img/logo1.2f334f21.png";